var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewPaymentsPayoneerTableAdmin',{attrs:{"filterGetParams":_vm.filterGetParams,"countFilterParams":_vm.countFilterParams},on:{"filter":_vm.filter,"changeFilter":_vm.changeFilter,"showMore":_vm.showMore,"resetFilter":_vm.resetFilter,"downloadFiles":_vm.downloadFiles,"massPay":_vm.massPay,"reload":_vm.reload}})
}
var staticRenderFns = []

export { render, staticRenderFns }